"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const axios_1 = require("axios");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const Widget_1 = __importDefault(require("~/components/UI/Widget"));
const actions_1 = require("~/store/actions");
const axiosInstance_1 = require("~/store/api/axiosInstance");
const consts_1 = require("~/store/consts");
const selectors_1 = require("~/store/selectors");
const AiChatWidget_module_scss_1 = __importDefault(require("./AiChatWidget.module.scss"));
const draw_1 = require("./draw");
function getErrorMessage(error) {
    if ((0, axios_1.isAxiosError)(error)) {
        return 'Sorry, the design service is temporarily unavailable. Please try again.';
    }
    if (error instanceof Error) {
        return error.message;
    }
    return 'Error: could not get a response.';
}
const greetingMessage = () => {
    return [
        "Hi! I'm your AI design assistant.\n",
        'I can build and edit assemblies in your project.',
        'I can build: Workbench, Enclosure, Machine Barrier Frame, Door, and Parallel Extrusions.\n',
        'Quick tips:',
        "Give dimensions in one go: '48x24x30' = width x depth x height, or '48x24' = width x depth.",
        "Edit what you just built: 'make it taller' or 'increase depth to 30'.",
        'Building multiple assemblies? Clear the project first.',
    ].join('\n');
};
function AIChatWidget() {
    const [messages, setMessages] = (0, react_1.useState)([{ role: 'ai', text: greetingMessage() }]);
    const [input, setInput] = (0, react_1.useState)('');
    const messagesEndRef = (0, react_1.useRef)(null);
    const textareaRef = (0, react_1.useRef)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [conversationState, setConversationState] = (0, react_1.useState)(null);
    const [trackedAssemblies, setTrackedAssemblies] = (0, react_1.useState)([]);
    const [lastTouchedId, setLastTouchedId] = (0, react_1.useState)();
    const [disambiguationState, setDisambiguationState] = (0, react_1.useState)(null);
    const catalogItems = (0, react_redux_1.useSelector)(selectors_1.selectAllCatalogItems);
    const projectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const isShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.AI_CHAT_WIDGET));
    const isUserLogged = (0, react_redux_1.useSelector)(selectors_1.selectIsUserLogged);
    const projectIdRef = (0, react_1.useRef)(projectId);
    const chatSessionRef = (0, react_1.useRef)(0);
    const requestControllerRef = (0, react_1.useRef)(null);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { dispatchToggleWidget } = (0, redux_1.bindActionCreators)({
        dispatchToggleWidget: actions_1.toggleWidget,
    }, dispatch);
    (0, react_1.useEffect)(() => {
        if (!isUserLogged && isShown) {
            dispatchToggleWidget({
                widgetName: consts_1.WIDGETS.AI_CHAT_WIDGET,
                show: false,
            });
            setConversationState(null);
            setTrackedAssemblies([]);
            setLastTouchedId(undefined);
        }
    }, [dispatchToggleWidget, isShown, isUserLogged]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (projectIdRef.current === projectId) {
            return;
        }
        projectIdRef.current = projectId;
        chatSessionRef.current += 1;
        (_a = requestControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        requestControllerRef.current = null;
        setMessages([{ role: 'ai', text: greetingMessage() }]);
        setInput('');
        setLoading(false);
        setConversationState(null);
        setTrackedAssemblies([]);
        setLastTouchedId(undefined);
        setDisambiguationState(null);
        (0, draw_1.clearHighlight)();
    }, [projectId]);
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);
    const MAX_TEXTAREA_HEIGHT = 67; // ~3 lines
    const resizeTextarea = () => {
        const el = textareaRef.current;
        if (!el) {
            return;
        }
        el.style.height = 'auto';
        el.style.overflowY = el.scrollHeight > MAX_TEXTAREA_HEIGHT ? 'auto' : 'hidden';
        el.style.height = `${el.scrollHeight}px`;
    };
    (0, react_1.useLayoutEffect)(() => {
        if (!isShown) {
            return;
        }
        resizeTextarea();
    }, [input, isShown, resizeTextarea]);
    (0, react_1.useLayoutEffect)(() => {
        var _a;
        if (!isShown) {
            return;
        }
        (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [isShown]);
    const sendQuery = (query, forcedTargetAssemblyId) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const chatSession = chatSessionRef.current;
        const requestController = new AbortController();
        requestControllerRef.current = requestController;
        setLoading(true);
        try {
            const { data } = yield axiosInstance_1.axiosInstance.post('/searchai', Object.assign(Object.assign({ query, state: conversationState !== null && conversationState !== void 0 ? conversationState : undefined, scene: trackedAssemblies }, (lastTouchedId && { lastTouchedId })), (forcedTargetAssemblyId && { forcedTargetAssemblyId })), { signal: requestController.signal });
            if (chatSession !== chatSessionRef.current) {
                return;
            }
            const responseResult = data;
            if (responseResult.state) {
                setConversationState(responseResult.state);
            }
            switch (responseResult.status) {
                case 'built': {
                    setMessages((prev) => [...prev, { role: 'ai', text: responseResult.text || 'Done.' }]);
                    if (!responseResult.assembly || !responseResult.items) {
                        break;
                    }
                    const freshAssembly = responseResult.assembly;
                    setTrackedAssemblies((prev) => [
                        ...prev.filter((assembly) => assembly.id !== freshAssembly.id),
                        freshAssembly,
                    ]);
                    setLastTouchedId(freshAssembly.id);
                    const applyResult = yield (0, draw_1.applyGeneratedProjectToScene)(catalogItems, {
                        items: responseResult.items,
                        assembly: freshAssembly,
                    });
                    if (chatSession !== chatSessionRef.current) {
                        return;
                    }
                    if (applyResult.skippedItems.length) {
                        setMessages((prev) => [
                            ...prev,
                            {
                                role: 'ai',
                                text: `I skipped ${applyResult.skippedItems.length} item(s) that were not available in the current catalog.`,
                            },
                        ]);
                    }
                    break;
                }
                case 'ask':
                case 'declined': {
                    setMessages((prev) => [...prev, { role: 'ai', text: responseResult.text || 'No response' }]);
                    break;
                }
                case 'choose': {
                    const clarificationText = responseResult.text || 'Multiple assemblies match. Which one did you mean?';
                    setMessages((prev) => [...prev, { role: 'ai', text: clarificationText }]);
                    setDisambiguationState({
                        query,
                        candidates: (_a = responseResult.candidates) !== null && _a !== void 0 ? _a : [],
                        selectedId: null,
                    });
                    break;
                }
                case 'cleared':
                    setMessages((prev) => [...prev, { role: 'ai', text: responseResult.text }]);
                    if (chatSession !== chatSessionRef.current) {
                        return;
                    }
                    (0, draw_1.clearGeneratedProjectFromScene)();
                    setConversationState(null);
                    setTrackedAssemblies([]);
                    setLastTouchedId(undefined);
                    break;
            }
        }
        catch (error) {
            if (chatSession === chatSessionRef.current && !requestController.signal.aborted) {
                setMessages((prev) => [...prev, { role: 'ai', text: getErrorMessage(error) }]);
            }
        }
        finally {
            if (chatSession === chatSessionRef.current) {
                setLoading(false);
            }
            if (requestControllerRef.current === requestController) {
                requestControllerRef.current = null;
            }
        }
    });
    const handleSend = () => __awaiter(this, void 0, void 0, function* () {
        const query = input.trim();
        if (!query || loading) {
            return;
        }
        // Clear any pending disambiguation state when user sends a new message.
        setDisambiguationState(null);
        (0, draw_1.clearHighlight)();
        setMessages((prev) => [...prev, { role: 'user', text: query }]);
        setInput('');
        yield sendQuery(query);
    });
    const handleCandidateClick = (candidate) => __awaiter(this, void 0, void 0, function* () {
        if (!disambiguationState || loading) {
            return;
        }
        if (disambiguationState.selectedId === candidate.id) {
            // Second click on same button — execute the edit.
            (0, draw_1.clearHighlight)(); // Must clear before sendQuery to avoid operating on a stale scene.
            setDisambiguationState(null);
            yield sendQuery(disambiguationState.query, candidate.id);
        }
        else {
            // First click (or switch) — preview: highlight and select.
            (0, draw_1.clearHighlight)();
            setDisambiguationState(Object.assign(Object.assign({}, disambiguationState), { selectedId: candidate.id }));
            (0, draw_1.highlightAssembly)(candidate.id);
        }
    });
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };
    if (!isUserLogged) {
        return null;
    }
    return (react_1.default.createElement(Widget_1.default, { widgetName: consts_1.WIDGETS.AI_CHAT_WIDGET, defaultSize: { width: 343, height: 400 }, minSize: { width: 343, height: 400 } },
        react_1.default.createElement("div", { className: AiChatWidget_module_scss_1.default.chatContainer },
            react_1.default.createElement("div", { className: AiChatWidget_module_scss_1.default.header }, "AI Chat"),
            react_1.default.createElement("div", { className: AiChatWidget_module_scss_1.default.messages },
                messages.length === 0 && react_1.default.createElement("span", { className: AiChatWidget_module_scss_1.default.placeholder }, "Ask me anything about your project..."),
                messages.map((msg, i) => (react_1.default.createElement("div", { key: `${msg.role}-${i}`, className: `${AiChatWidget_module_scss_1.default.message} ${msg.role === 'user' ? AiChatWidget_module_scss_1.default.user : AiChatWidget_module_scss_1.default.ai}`, style: { whiteSpace: 'pre-line' } }, msg.text))),
                loading && (react_1.default.createElement("div", { className: `${AiChatWidget_module_scss_1.default.message} ${AiChatWidget_module_scss_1.default.ai}` },
                    react_1.default.createElement("span", { className: AiChatWidget_module_scss_1.default.loadingDots },
                        react_1.default.createElement("span", null, "."),
                        react_1.default.createElement("span", null, "."),
                        react_1.default.createElement("span", null, ".")))),
                react_1.default.createElement("div", { ref: messagesEndRef })),
            disambiguationState && (react_1.default.createElement("div", { className: AiChatWidget_module_scss_1.default.candidateButtons }, disambiguationState.candidates.map((c) => {
                const isSelected = disambiguationState.selectedId === c.id;
                return (react_1.default.createElement("button", { key: c.id, type: "button", className: `${AiChatWidget_module_scss_1.default.candidateBtn} ${isSelected ? AiChatWidget_module_scss_1.default.candidateBtnSelected : ''}`, onClick: () => handleCandidateClick(c), disabled: loading, title: isSelected ? 'Click again to apply' : 'Click to preview' }, isSelected ? `${c.label} ✓` : c.label));
            }))),
            react_1.default.createElement("div", { className: AiChatWidget_module_scss_1.default.inputRow },
                react_1.default.createElement("textarea", { ref: textareaRef, className: AiChatWidget_module_scss_1.default.input, value: input, rows: 1, onChange: (e) => setInput(e.target.value), onKeyDown: handleKeyDown, placeholder: "Type a message... (Shift+Enter for new line)" }),
                react_1.default.createElement("button", { className: AiChatWidget_module_scss_1.default.sendBtn, type: "button", onClick: handleSend, disabled: loading || !input.trim() }, "Send")))));
}
exports.default = AIChatWidget;
